import React from "react";
import PropTypes from "prop-types";
import Dialog from "./Dialog";

/**
 * Confirm dialog
 * @module
 * @param {bool} isOpen - Is dialog open?
 * @param {func} onClose - Function invoked on dialog close
 * @param {func} onCancel - Function invoked on dialog cancel
 * @param {func} onConfirm - Function invoked on dialog confirm
 * @param {string} text - Text of dialog
 * @param {string} [confirmText] - Confirm button text
 * @param {string} [cancelText] - Cancel button text
 */
const ConfirmDialog = (props) => {
  return (
    <Dialog
      title="Potvrdenie"
      onEsc={props.onClose}
      onClose={props.onClose}
      onCancel={props.onCancel}
      onConfirm={props.onConfirm}
      isOpen={props.isOpen}
      confirmText={props.confirmText}
      cancelText={props.cancelText}
    >
      <p style={{ margin: "15px", textAlign: "center" }}>{props.text}</p>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
};

export default ConfirmDialog;
